import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { SubheaderClassName } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const LocationListDetailContainer: StyleRule = () => ({
    gridGap: pxToRem(21),
    padding: pxArrayToRem([31, 9, 25, 0]),
});

export const LocationListDetail: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([18, 0, 18]),
    [`& .${labelClassName}`]: {
        fontSize: theme.siteVariables.fontSizes['label03-alt'],
    },

    // location title header
    '& > div:first-child': {
        marginBottom: pxToRem(29),
        // header text
        [`& .${SubheaderClassName}`]: {
            letterSpacing: 0,
            fontSize: theme.siteVariables.fontSizes['label03-alt'],
            marginBottom: pxToRem(4),
        },
        // close icon button
        '& > button': {
            marginTop: pxToRem(-14.6),
        },
    },

    // location type, address, phone, online orders, etc
    '& > div:nth-child(2)': {
        rowGap: pxToRem(5),
        gridTemplateColumns: `${pxToRem(164)} 1fr`,

        [`& .${labelClassName}`]: {
            fontSize: pxToRem(16),
        },

        // clickToReveal full address with ellipsis
        '& > div:nth-child(4)': {
            '& > div': {
                letterSpacing: 0,
            },
        },

        // clickToReveal phone number with ellipsis
        '& > div:nth-child(6)': {
            '& > div': {
                letterSpacing: 0,
            },
        },
    },

    // view profile, enquire, heart buttons, etc
    '& > div:last-child': {
        margin: pxArrayToRem([30, 0, 13, 0]),
        alignItems: 'center',

        '& div': {
            letterSpacing: 0,
        },

        // view profile button
        '& > div:first-child a': {
            textDecorationLine: 'underline',
            lineHeight: '130%',
        },
    },
});

export const LocationListDetailEnquiryButton: StyleRule = ({ theme }) => ({
    [`&.${buttonClassName}`]: {
        border: `1px solid ${theme.siteVariables.colorScheme.default?.foreground}`,
        padding: pxArrayToRem([15, 23]),
        marginLeft: pxToRem(50),
        textTransform: 'uppercase',
    },
});

export const LocationListDistance: StyleRule = () => ({
    [`&.${buttonClassName}`]: {
        background: 'transparent',
        cursor: 'default',
        padding: 0,

        [`&:hover`]: {
            background: 'transparent',
        },

        [`& .${svgIconClassName}`]: {
            width: pxToRem(20),
            height: pxToRem(20),
        },
    },
});
